import { Flex, Modal, Button } from '@ui/index'
import { SafeMessage } from '../ui/safe-message'


/** Свойства окна извещения */
export interface IModalNotice {
    isOpen: boolean
    
    headerText?: string
    contentText?: string

    handleButtonOk?: () => void
}


/** Окно извещения */
export const ModalNotice = ({isOpen, headerText, contentText, handleButtonOk}: IModalNotice) => {
    return <Modal isOpen={isOpen} isEsc isWrapper onCancel={handleButtonOk} onOk={handleButtonOk}>
        <Flex className='modal_container'>
            <Flex className='modal_container-header'>
                <h4>{headerText || 'Извещение...'}</h4>
            </Flex>

            <Flex gap='4px' className='modal_container-body'>
                <Flex className='modal_container-content'>
                    <span style={{fontSize: '15px', letterSpacing: '1.5px', lineHeight: '140%'}}>
                        <SafeMessage message={contentText} fallback='Привет:<br/>Вы не указали текст!' />
                    </span>
                </Flex>

                <div style={{gap: '6px', display: 'grid', gridTemplateColumns: '1fr'}}>
                    <Button width='100%' onClick={handleButtonOk}>ХОРОШО</Button>
                </div>
            </Flex>
        </Flex>
    </Modal>
}